export const statusTypes = {
    1: 'Pending',
    2: 'Approved',
    3: 'Rejected',
    4: 'Draft'
}